import {Base,Axios} from "@/api/Base"

export class GiDownAll extends Base {

    path = "gi/downAll"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}